<template>
    <div class="payment-received-header">
        <div class="icon" :class="{ circlein: animateIcon }">
            <i class="fal fa-check"></i>
        </div>
        <div class="state">
            {{ trans.paymentReceivedPopover.received }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { trans } from "@/app/localization/Trans";

    defineProps<{
        animateIcon: boolean;
    }>();
</script>

<style lang="scss">
    @use "./../../../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../../../assets/styles/scss/shared/_variables.scss";

    .payment-received-popover-content .payment-received-header {
        .icon {
            margin: auto;
            height: 70px;
            width: 70px;
            border-radius: 35px;
            background-color: colors.$green;
            text-align: center;
            transform: translate3d(0, 20px, 0);
            opacity: 0;
            transition:
                transform 0.8s variables.$easeOutExpo,
                opacity 0.8s variables.$easeOutExpo;

            > .fal {
                display: inline-block;
                line-height: 70px;
                color: #fff;
                font-size: 30px;
                transform: rotate(120deg);
                opacity: 0;
                transition:
                    transform 1.2s variables.$easeOutExpo,
                    opacity 1.2s variables.$easeOutExpo;
            }

            &.circlein {
                transform: translate3d(0, 0, 0);
                opacity: 1;

                > .fal {
                    transform: rotate(0deg);
                    opacity: 1;
                }
            }
        }

        .state {
            font-size: 14px;
            font-weight: 700;
            text-align: center;
            padding: 19px 0 1px 0;
            line-height: 22px;
        }
    }
</style>
